<div class="searchbox-container">
    <ng-select
        [loadingText]="'defaults.loading' | translation | async"
        [notFoundText]="'defaults.noItemsFound' | translation | async"
        class="searchbox"
        [searchWhileComposing]="false"
        [formControl]="searchCtrl"
        groupBy="Type"
        [items]="searchResult$ | async"
        bindLabel="ShowName"
        (change)="openDeviceAssets($event)"
        (close)="closeSearch()"
        [placeholder]="'search.placeholder' | translation | async"
        [minTermLength]="3"
        [typeahead]="typeaheadSubject"
        [typeToSearchText]="'search.typeToSearch' | translation | async"
        (search)="checkInput($event)"
        [notFoundText]="'search.noDataFound' | translation | async"
        #appSearch
    >
        <ng-template ng-optgroup-tmp let-item="item">
            {{ item.Type }}
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
            <div class="text-search-suggestion" [ngbTooltip]="item.ShowName" placement="auto" [openDelay]="0" class="text-truncate">{{ item.ShowName }}</div>
        </ng-template>
    </ng-select>
    <i class="fas fa-search fa-sm"></i>
</div>
